import React from 'react';
import { Box, Group, Skeleton } from "@mantine/core";

interface ImpactSkeletonProps {
  count?: number; // Number of impact items to show (default: 2)
}

const ImpactSkeleton: React.FC<ImpactSkeletonProps> = ({ count = 2 }) => {
  return (
    <Group noWrap>
      {Array.from({ length: count }).map((_, index) => (
        <Box 
          key={index}
          style={{  
            borderLeft: index > 0 ? '1px solid #D8D8DB' : 'none',
            paddingLeft: index > 0 ? '16px' : '0px',
            marginBottom: '20px'
          }}
        >
          <Skeleton 
            height={24} 
            width={60} 
            radius="sm"
            style={{ 
              marginBottom: '-4px'
            }}
          />
          <Skeleton 
            height={14} 
            width={80} 
            radius="sm"
            mt={4}
          />
        </Box>
      ))}
    </Group>
  );
};

export default ImpactSkeleton;
